import React from 'react';
import {
    Box,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Typography
} from '@mui/material';

import MedicareUpload from './MedicareUpload';

const Medicare = ({
    showMedicareUpload,
    anyTempVisaSelected,
    isMedicareMandatory,
    SetShowMedicareUpload,
    SetMedicareImages,
    medicareImages = [],
    error = '',
    storedUrls = [],
    onRemoveStored,
}) => {

    return <Box>
        {
            anyTempVisaSelected &&
            <Box sx={{
                p: 3,
                mt: 3,
                bgcolor: '#F8FAFC',
                border: '1px solid #E2E8F0',
                borderRadius: '12px',
                display: 'flex',
                flexDirection: 'column',
            }}>
                <FormControl>
                    <FormLabel
                        id="demo-radio-buttons-group-label"
                        sx={{
                            fontWeight: 600,
                            color: '#1E293B',
                            mb: 1,
                            '&.Mui-focused': {
                                color: '#1E293B',
                            },
                        }}
                    >
                        Do you have a new Medicare Card?
                    </FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="false"
                        name="radio-buttons-group"
                        onChange={(e) => {
                            SetShowMedicareUpload(e.target.value === 'true');
                        }}
                    >
                        <FormControlLabel
                            value="true"
                            control={
                                <Radio
                                    sx={{
                                        color: '#059669',
                                        '&.Mui-checked': {
                                            color: '#059669',
                                        },
                                    }}
                                />
                            }
                            label={<Typography sx={{ color: '#334155', fontWeight: 500 }}>Yes</Typography>}
                        />
                        <FormControlLabel
                            value="false"
                            control={
                                <Radio
                                    sx={{
                                        color: '#059669',
                                        '&.Mui-checked': {
                                            color: '#059669',
                                        },
                                    }}
                                />
                            }
                            label={<Typography sx={{ color: '#334155', fontWeight: 500 }}>No</Typography>}
                        />
                    </RadioGroup>
                </FormControl>
            </Box>
        }
        {
            isMedicareMandatory && (!anyTempVisaSelected || showMedicareUpload) &&
            <Box sx={{
                p: 3,
                mt: 3,
                bgcolor: '#F8FAFC',
                border: '1px solid #E2E8F0',
                borderRadius: '12px',
                display: 'flex',
                flexDirection: 'column',
            }}>
                <Typography sx={{ fontWeight: 700, color: '#1E293B', fontSize: '16px', mb: 1 }}>
                    Medicare Card Upload
                </Typography>
                <Typography sx={{ color: '#475569', fontSize: '14px', mb: 2 }}>
                    Upload the front and back of the card. A sample is shown above the upload boxes.
                </Typography>
                <Box>
                    <MedicareUpload
                        SetMedicareImages={SetMedicareImages}
                        files={medicareImages}
                        error={error}
                        storedUrls={storedUrls}
                        onRemoveStored={onRemoveStored}
                    />
                </Box>
            </Box>
        }
    </Box >
};

export default Medicare;
